/**
 * Locales where `payment-config="nvstore-standard-payments"` is omitted on UCP payment web components.
 */
export const LOCALES_WITHOUT_NVSTORE_PAYMENT_CONFIG: readonly string[] = ['en-ap', 'en-in'];
